import React, { Component } from 'react';
import './addCompany.scss';
import Footer from '../Footer/footer';
import Header from '../Header/header';
import addCompany from '../../services/addCompany';
import { Navigate } from 'react-router-dom';
import toastNotify from '../../utils/toastNotifier';
import { industries } from '../../utils/industries';
import getCompaniesList from '../../services/getAllCompaniesDetails';
import withRouter from '../withRouter';

class AddCompany extends React.Component {
    constructor() {
        super();
        this.state = {
            companyDetails: [],
            nameLike: '',
            redirectToCompanyList: false,
            showTable: true,
            pageNumber: 1,
            tokencheck:true
        }

        this.oldcompanyDetails = [];
        this.pageContent = 20;
        this.status = 1;
    }

    companyType = {
        "1": "Direct Employer",
        "2": "Recruitment Firm",
    }

    redirectHandler = () => {
        this.setState({
            redirectToCompanyList: true
        })
    }

    getCompaniesData = async (usePageOne) => {
        let companyListData = await getCompaniesList(this.status, usePageOne ? 1 : this.state.pageNumber, this.pageContent, this.state.nameLike);
        return companyListData;
    }

    componentDidMount() {
        this.getCompaniesData().then((res) => {
            this.oldcompanyDetails = this.oldcompanyDetails.concat(res);
            if (res.length == this.pageContent) {
                window.addEventListener('scroll', this.listenToScroll);
            }
            this.setState({
                companyDetails: this.oldcompanyDetails
            });
        });
    }
    componentWillUnmount() {
        window.removeEventListener('scroll', this.listenToScroll);
    }

    listenToScroll = (e) => {
        let table = document.getElementById("companyListTable");
        const winScroll = document.body.scrollTop || document.documentElement.scrollTop;
        const tableScroll = table.scrollHeight - 400;
        const tableEnd = winScroll / tableScroll < 0.7 ? false : true;
        if (tableEnd) {
            window.removeEventListener('scroll', this.listenToScroll);
            this.setState({
                pageNumber: this.state.pageNumber + 1
            });
            this.getCompaniesData().then((res) => {

                this.oldcompanyDetails = this.oldcompanyDetails.concat(res);
                if (res.length == this.pageContent) {
                    window.addEventListener('scroll', this.listenToScroll);
                }
                this.setState({
                    companyDetails: this.oldcompanyDetails
                });
            });
        }
    }

    handleCompanyNameFilterChange = (e) => {
        let val = e.target.value;
        this.setState({ nameLike: val })
    }

    handleFilterButton = (e) => {
        e.preventDefault();
        this.setState({
            pageNumber: 1
        });
        this.oldcompanyDetails = [];
        this.getCompaniesData(true)
            .then((res) => {
                if (res && res.length) {
                    this.setState({
                        showTable: true
                    });
                } else {
                    this.setState({
                        showTable: false
                    });
                }
                this.oldcompanyDetails = this.oldcompanyDetails.concat(res);
                if (res.length == this.pageContent) {
                    window.addEventListener('scroll', this.listenToScroll);
                }
                this.setState({
                    companyDetails: this.oldcompanyDetails
                });
            });

    }

    handleClearFilterButton = () => {
        window.location.reload();
    }

    handleIndustry = (id) => {
        if (id) {
            try {
                let industry = industries.filter(ind => {
                    return (ind["id"] == id)
                })
                return industry[0]['name']
            } catch{
                return "";
            }
        }
    }

    companySubmit = async (e) => {
        let companyDetails = e.target.value;
        companyDetails = companyDetails.split('~');

        const data = {
            companyName: companyDetails[0],
            companyCode: companyDetails[1]
        }
        let value = await addCompany(data);
        if (value && value.status.code == 10200) {
            toastNotify(1, "Successfully Added Company");
        }
        else {

            const response = JSON.parse(result.request.response);
            const code = response?.status?.code;
            if (code == 10411 || code == 10412 || code == 10416 || code == 10417) {
                this.setState({ tokencheck: false });
                cookie.delete_cookie(process.env.REACT_APP_COOKIE_NAME);
                cookie.delete_cookie('loginProfileInfo');
                AuthObject.isAuthenticated = false;
            }
            else{
                toastNotify(3, "Company already exists");
            }
        }
    }

    render() {
        
        if (!this.state.tokencheck) {
            return <Navigate to={'/'} />
        }

        if (this.state.redirectToCompanyList) {
            return <Navigate to={'/company'} />
        }

        let rows;
        if (this.state.companyDetails) {
            rows = (
                this.state.companyDetails.map((item, index) => {

                    return (
                        <tr key={index}>
                            <td>
                                <div className="checkboxes">
                                    <p>{item["id"]}</p>
                                </div>
                            </td>

                            <td>
                                <div className="checkboxes">
                                    {item["domains"] && item["domains"].length > 0 && item["domains"].map((domain, count) => (
                                        <p key={count}>{domain}</p>))
                                    }
                                </div>
                            </td>

                            <td>
                                <div className="checkboxes">
                                    <p>{item["name"]}</p>
                                </div>
                            </td>
                            <td>
                                <div className="checkboxes">
                                    <p>{item["displayName"]}</p>
                                </div>
                            </td>
                            <td>
                                <div className="checkboxes">
                                    <p>{this.companyType[item["type"]]}</p>
                                </div>
                            </td>
                            <td>
                                <div className="checkbox">
                                    <p>{this.handleIndustry(item["industry"])}</p>
                                </div>
                            </td>
                            <td>
                                <div className="checkbox">
                                    <p>{item["infoedgeId"]}</p>
                                </div>
                            </td>
                            <td>
                                <button className="color_green btn-default" value={`${item["name"]}~${item["id"]}`} onClick={this.companySubmit}>Submit</button>
                            </td>
                        </tr>
                    )
                })
            )
        }

        return (
            <div>
                <Header />

                <div className="companyList_header">
                    <div className="wrapper">
                        <div className="wrapperButton" onClick={this.redirectHandler}>
                            &lt; Back To Company List
                        </div>
                        <div id="company_message"></div>
                    </div>
                    <div className="top">
                        <div className="company-heading">Add Company</div>
                    </div>
                    <div className="table-filter-options">
                        <div className='topFilter'>
                            <div className="company-filter">
                                <div className="">
                                    <p className="form-group-heading">Company Name</p>
                                    <input className="input-class spacing" type="text" placeholder="Search Company Name" onChange={this.handleCompanyNameFilterChange} />
                                </div>
                            </div>
                            <div className="filter-div">
                                <div className="filter-options-submit">
                                    <button type="button" className="submit-filter-options" onClick={this.handleFilterButton}>
                                        <span>Filter</span>
                                    </button>
                                </div>
                                <div className="filter-options-clear" onClick={this.handleClearFilterButton}>
                                    <a className="clear-filter-options">Clear</a>
                                </div>
                            </div>
                        </div>
                        <div className='bottomFilter'>
                            <p id="notify"><b>* If your company is not present in the list, please register </b><a href="http://admin.iimjobs.com/companyManagement" target="_blank"><b> here</b></a> </p>
                        </div>
                    </div>

                    <div className="noRecordText" style={{ display: this.state.showTable ? 'none' : 'block' }}>Company is not found !</div>
                    <div className="companyListtableContainer" style={{ display: this.state.showTable ? 'block' : 'none' }}>
                        <table id="companyListTable">
                            <thead id="head_color">
                                <tr>
                                    <th>Company Id</th>
                                    <th>Domains</th>
                                    <th>Name</th>
                                    <th>Display Name</th>
                                    <th>Company Type</th>
                                    <th>Industry</th>
                                    <th>InfoedgeId</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {rows}
                            </tbody>
                        </table>
                    </div>
                </div>
                <Footer />
            </div>
        );
    }

}

export default withRouter(AddCompany);